import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { DataValidator } from 'app/tools/custom-formgroup-validator';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-data-fim-concessao',
  templateUrl: './text-data-fim-concessao.component.html',
  styleUrls: ['./text-data-fim-concessao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextDataFimConcessaoComponent implements OnInit {

  formGroup: FormGroup;
  now: string = new Date().toISOString().split('T')[0];
  
  constructor(
    private _controlContainer: ControlContainer
  ) { }
  
  ngOnInit() { }

  async ngAfterViewInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.get('dtInicioConcessao').valueChanges.subscribe(value => this._validators(value));
  }
  
  private _validators(dtInicioConcessao) {
    const date = new Date();
    date.setHours(23, 59, 59, 59);
    this.formGroup.get('dtFinalConcessao').setValidators([DataValidator.min(dtInicioConcessao)]);
    this.formGroup.get('dtFinalConcessao').updateValueAndValidity();
  }


}
